import { NgModule } from '@angular/core';

import { DeviceImageComponent } from './device-image.component';
import { DeviceImageProvider } from './device-image.provider';

@NgModule({
	providers: [
		{
			provide: DeviceImageProvider,
			useValue: <DeviceImageProvider>{
				getImage: (model) => ({
					live: `${model}-live.svg`,
					virtual: `${model}-virtual.svg`
				})
			}
		}
	],
	imports: [DeviceImageComponent],
	exports: [DeviceImageComponent]
})
export class DeviceImageTestingModule {}
